import styled from 'styled-components';

type Props = { isError?: boolean };

export const ToastOuterContainer = styled.div`
  .munitech_toast {
    .Toastify__toast {
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
      min-width: 300px;
      width: auto;
      max-width: 450px;
      min-height: 60px;
    }
  }
`;
export const ToastInnerContainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: end;
  padding: 15px;
  line-height: 24px;
  color: #767b8a;
  ${({ isError }: Props) => {
    if (isError) {
      return `svg {
      g {
        fill: red;
      }
    }`;
    }
  }}
`;
export const ToastMessage = styled.div`
  margin-left: 5px;
`;
